import "./index.scss";
export default function ErrorPage() {
  return (
    <div className="error-page">
      <h6> خطایی رخ داده لطفا دو باره امتحان کنید ...</h6>
    </div>
  );
}
